const BlockCarousel = class extends HTMLElement {
    constructor() {
    super()

    this.swiper = null
    // this.options = JSON.parse(this.dataset.options)
    try {
      this.options = JSON.parse(this.dataset.options || '{}')
    } catch (error) {
      console.error('Invalid JSON in carousel options:', error)
      this.options = {}
    }
    this.prevEl = this.querySelector('[data-block-carousel-prev]')
    this.nextEl = this.querySelector('[data-block-carousel-next]')
  }

  connectedCallback () {
    const slider = this.querySelector('.swiper')
    if (!slider) { return }

    const options = {
      ...(this.options.carousel_type === 'fade' && { effect: 'fade' }),
      ...(this.options.autoplay_delay > 0 && {
        autoplay: {
          delay: this.options.autoplay_delay * 1000
        }
      }),
      loop: this.options.loop,
      slidesPerView: 1,
      centeredSlides: true,
      draggable: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      ...(this.prevEl && this.nextEl && {
        navigation: {
          nextEl: this.nextEl,
          prevEl: this.prevEl
        }
      })
    }

    this.swiper = new Swiper(slider, options)
  }
}

if (typeof window.customElements.get('block-carousel') === 'undefined') {
  window.customElements.define('block-carousel', BlockCarousel)
}